import ScalarCardHeader_vue_vue_type_script_setup_true_lang_default from "./ScalarCardHeader.vue.script.js";
//#region src/components/ScalarCard/ScalarCardHeader.vue
var ScalarCardHeader_default = ScalarCardHeader_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarCardHeader_default as default };

//# sourceMappingURL=ScalarCardHeader.vue.js.map